import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {ReportIccidsLazy} from "@containers/reports/readyReports/reportIccids/ReportIccids.lazy";
import UserAccessRoot from "@containers/account/access/userAccess/UserAccessRoot";

const ReportIccidsPage = () => {
	return (
		<PageLayout>
			<UserAccessRoot
				keys={['ROLE_SUPER_TENANT']}
			>
				<Suspense
					fallback={<SpinnerCustom/>}
				>
					<ReportIccidsLazy/>
				</Suspense>
			</UserAccessRoot>
		
		</PageLayout>
	);
};

export default ReportIccidsPage;